import { Injectable } from '@angular/core';

import { ApiClient, ThemeStateService } from '@canvas/four-r-digital';

import { adminUiSettingsUrl, themeSettingsUrl } from '../ApiKeys';
import { AdminUiSettings } from '../dtos/admin-ui-settings';
import { BehaviorSubject, filter, map, switchMap } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { HttpParams } from '@angular/common/http';
import { RolesService } from './roles.service';

@Injectable({
  providedIn: 'root',
})
export class SettingsStateService {
  constructor(
    private apiClient: ApiClient,
    private titleService: Title,
    private rolesService: RolesService,
    private themeStateService: ThemeStateService
  ) {
    this.loadUiSettings();
  }

  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  private isLoadedSubject = new BehaviorSubject<boolean>(false);

  private settingsSubject = new BehaviorSubject<AdminUiSettings | null>(null);

  isLoading$ = this.isLoadingSubject.asObservable();
  isLoaded$ = this.isLoadedSubject.asObservable();
  settings$ = this.settingsSubject.asObservable().pipe(filter((x) => !!x));
  themeSettings$ = this.themeStateService.themeSettings$;

  coreCanvasModules$ = this.settings$.pipe(map((x) => x.coreCanvasModules));

  loadUiSettings() {
    this.isLoadingSubject.next(true);

    this.rolesService.activeRole$
      .pipe(
        switchMap((role) => {
          const params = new HttpParams().set('role', role);
          return this.apiClient.get<AdminUiSettings>(adminUiSettingsUrl(), {
            params,
          });
        })
      )
      .subscribe({
        next: (settings) => {
          if (settings) {
            this.settingsSubject.next(settings);
          }

          this.isLoadedSubject.next(true);
          this.isLoadingSubject.next(false);
        },
        error: (e) => {
          console.log(e);
          this.isLoadedSubject.next(true);
          this.isLoadingSubject.next(false);
        },
      });

    this.themeStateService.loadThemeSettings(themeSettingsUrl());

    this.themeSettings$.subscribe((themeSettings) => {
      this.titleService.setTitle(themeSettings.adminUi.pageTitle);
    });
  }
}
